export const DividerStyle = {
  // Styles for the base style
  baseStyle: () => ({
    borderColor: 'border.base',
  }),
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {},
}
